import React, { useState, useEffect } from "react";
import { Modal, Button, Typography } from "antd";
import { FileProtectOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import TermosUsoService from "services/TermosUsoService";
import { TermosTexto } from "views/termos-views/conteudo";

const { Title, Paragraph } = Typography;

/**
 * Modal bloqueante de aceite dos termos de uso. Exibido quando o usuário
 * logado ainda não aceitou a versão vigente (controlada pelo back).
 * Não tem como fechar sem aceitar. O texto completo expande dentro do
 * próprio modal — o usuário não sai do fluxo.
 */
const TermosUsoModal = () => {
	const [visible, setVisible] = useState(false);
	const [versao, setVersao] = useState(null);
	const [loading, setLoading] = useState(false);
	const [mostrarTexto, setMostrarTexto] = useState(false);

	useEffect(() => {
		let ativo = true;

		TermosUsoService.obterStatus()
			.then((status) => {
				if (ativo && status?.precisa_aceitar) {
					setVersao(status.versao_atual);
					setVisible(true);
				}
			})
			.catch(() => {
				// Sem status não bloqueia o uso; o modal volta no próximo load
			});

		return () => {
			ativo = false;
		};
	}, []);

	const handleAceitar = () => {
		setLoading(true);
		TermosUsoService.aceitar(versao)
			.then(() => {
				setVisible(false);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<Modal
			visible={visible}
			closable={false}
			maskClosable={false}
			keyboard={false}
			footer={null}
			centered
			width={mostrarTexto ? 760 : 520}
		>
			<div style={{ textAlign: "center", padding: "16px 8px" }}>
				<FileProtectOutlined
					style={{
						fontSize: "48px",
						color: "#ff8034",
						marginBottom: "20px",
					}}
				/>

				<Title level={3} style={{ marginBottom: "16px" }}>
					Atualizamos nossos termos de uso
				</Title>

				<Paragraph style={{ fontSize: "16px", marginBottom: "16px" }}>
					Para continuar utilizando a plataforma, você precisa ler e
					aceitar os nossos termos de uso e política de privacidade.
				</Paragraph>

				<Button
					type="link"
					onClick={() => setMostrarTexto(!mostrarTexto)}
					icon={mostrarTexto ? <UpOutlined /> : <DownOutlined />}
					style={{ marginBottom: "16px" }}
				>
					{mostrarTexto
						? "Ocultar os termos"
						: "Visualizar os termos de uso e a política de privacidade"}
				</Button>

				{mostrarTexto && (
					<div
						style={{
							maxHeight: "45vh",
							overflowY: "auto",
							border: "1px solid #e5e7eb",
							borderRadius: "8px",
							padding: "16px 20px",
							marginBottom: "20px",
							backgroundColor: "#fafafa",
						}}
					>
						<TermosTexto />
					</div>
				)}

				<Button
					type="primary"
					size="large"
					block
					loading={loading}
					onClick={handleAceitar}
				>
					Li e aceito os termos de uso
				</Button>
			</div>
		</Modal>
	);
};

export default TermosUsoModal;
